// export const Servers = {
//     API: "https://shopapi.triaxiswork.com/",
//     FILES: "https://shopapi.triaxiswork.com/public/",
//     TENANTID: process.env.REACT_APP_TENANT_ID || '6752eb10f77c107c20c924aa',
// }

export const Servers = {
    API: process.env.REACT_APP_API_URL || "http://localhost:4000/",
    FILES: process.env.REACT_APP_FILES || "http://localhost:4000/public/",
    TENANTID: process.env.REACT_APP_TENANT_ID || '6752eb10f77c107c20c924aa',
    FILE_URL: process.env.R2_OBJECT_ENDPOINT || 'https://pub-1b14e58741034973a6118a1e4f834f5a.r2.dev',
}